import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, MapPin, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";

export default function Contacto() {
  const { t } = useLang();
  const cards = [
    { icon: MessageCircle, label: t.contact.whatsapp, value: "+57 310 684 6758", href: "https://wa.me/573106846758", testid: "contacto-whatsapp" },
    { icon: Instagram, label: t.contact.instagram, value: "@pame.3d", href: "https://instagram.com/pame.3d", testid: "contacto-instagram" },
    { icon: Mail, label: t.contact.email, value: "pamelamg98@gmail.com", href: "mailto:pamelamg98@gmail.com", testid: "contacto-email" },
    { icon: MapPin, label: t.contactPage.areaLabel, value: t.contactPage.area, href: null, testid: "contacto-area" },
  ];
  return (
    <div data-testid="contact-page" className="pt-16 min-h-screen">
      <Seo page="contacto" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#C86A4B] font-bold mb-3">{t.contact.title}</p>
          <h1 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#132A1D] tracking-tight">{t.contactPage.title}</h1>
          <p className="text-[#5C5C5C] mt-4 max-w-xl leading-relaxed">{t.contactPage.sub}</p>
        </Reveal>
        <div className="grid sm:grid-cols-2 gap-4 md:gap-6 mt-14">
          {cards.map((c, i) => (
            <Reveal key={c.testid} delay={0.06 * i}>
              <div data-testid={c.testid} className="bg-[#EFECE6] rounded-2xl p-6 md:p-8 h-full flex items-start gap-4">
                <c.icon size={22} className="text-[#C86A4B] mt-1 shrink-0" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-[#5C5C5C] mb-1">{c.label}</p>
                  {c.href ? (
                    <a href={c.href} target="_blank" rel="noopener noreferrer" className="font-serif-d text-xl md:text-2xl font-semibold text-[#132A1D] hover:text-[#2E5A3B] transition-colors duration-200">{c.value}</a>
                  ) : (
                    <p className="font-serif-d text-xl md:text-2xl font-semibold text-[#132A1D]">{c.value}</p>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="mt-16 md:mt-24 grid md:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="font-serif-d text-3xl md:text-4xl font-semibold text-[#132A1D] mb-4">{t.contactPage.h2}</h2>
            <p className="text-[#5C5C5C] leading-relaxed">{t.contactPage.body}</p>
          </div>
          <div className="flex flex-col gap-3">
            <a href="https://wa.me/573106846758" target="_blank" rel="noopener noreferrer" data-testid="contacto-cta-whatsapp"
              className="inline-flex items-center justify-between gap-2 rounded-full bg-[#2E5A3B] text-white px-7 py-3.5 text-sm font-semibold hover:bg-[#C86A4B] transition-colors duration-300">
              {t.contactPage.ctaWa} <ArrowRight size={16} />
            </a>
            <Link to="/disena" data-testid="contacto-cta-disena"
              className="inline-flex items-center justify-between gap-2 rounded-full border border-black/15 text-[#132A1D] px-7 py-3.5 text-sm font-semibold hover:bg-[#EFECE6] transition-colors duration-300">
              {t.contactPage.ctaDisena} <ArrowRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
